import { create } from 'zustand';

const SIDEBAR_KEY = 'keep.sidebarExpanded';

function readSidebarPreference(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_KEY) !== 'false';
  } catch {
    return true;
  }
}

interface UiState {
  /** Bureau : menu latéral déplié ou réduit aux icônes. Mobile : tiroir ouvert ou fermé. */
  sidebarExpanded: boolean;
  mobileSidebarOpen: boolean;
  toggleSidebar: (isMobile: boolean) => void;
  closeMobileSidebar: () => void;

  /** Notes sélectionnées (sélection multiple). */
  selection: ReadonlySet<string>;
  toggleSelected: (id: string) => void;
  setSelection: (ids: Iterable<string>) => void;
  clearSelection: () => void;

  /** Ouvre la boîte de dialogue « Modifier les libellés ». */
  labelsDialogOpen: boolean;
  setLabelsDialogOpen: (open: boolean) => void;
  settingsOpen: boolean;
  setSettingsOpen: (open: boolean) => void;
  importOpen: boolean;
  setImportOpen: (open: boolean) => void;
}

export const useUi = create<UiState>((set) => ({
  sidebarExpanded: readSidebarPreference(),
  mobileSidebarOpen: false,
  toggleSidebar: (isMobile) =>
    set((state) => {
      if (isMobile) return { mobileSidebarOpen: !state.mobileSidebarOpen };
      const sidebarExpanded = !state.sidebarExpanded;
      try {
        localStorage.setItem(SIDEBAR_KEY, String(sidebarExpanded));
      } catch {
        // stockage indisponible (navigation privée…) : la préférence ne sera simplement pas retenue
      }
      return { sidebarExpanded };
    }),
  closeMobileSidebar: () => set({ mobileSidebarOpen: false }),

  selection: new Set(),
  toggleSelected: (id) =>
    set((state) => {
      const selection = new Set(state.selection);
      if (selection.has(id)) selection.delete(id);
      else selection.add(id);
      return { selection };
    }),
  setSelection: (ids) => set({ selection: new Set(ids) }),
  clearSelection: () => set((state) => (state.selection.size ? { selection: new Set() } : state)),

  labelsDialogOpen: false,
  setLabelsDialogOpen: (labelsDialogOpen) => set({ labelsDialogOpen }),
  settingsOpen: false,
  setSettingsOpen: (settingsOpen) => set({ settingsOpen }),
  importOpen: false,
  setImportOpen: (importOpen) => set({ importOpen }),
}));
